import { isFailure, sessionStorageProxy } from "@sportal/api";

import { Notificator, NotificationActionTypes } from "../../../notification";
import { getSubscriberId } from "../../../../store/info/info.selectors";
import { SBThunkAction } from "../../../../store/redux.types";
import { SessionStorageKeys } from "../../../../services";

export const clearHistory =
  (metrics: string[]): SBThunkAction<void, NotificationActionTypes> =>
  async (dispatch, getState, { api }) => {
    const id = getSubscriberId(getState());

    const result = await api.ssm.history.clear(id, metrics);

    if (isFailure(result)) {
      dispatch(Notificator.error("failed_to_delete_data"));
      return;
    }

    sessionStorageProxy.removeItem(SessionStorageKeys.Reports);

    dispatch(
      Notificator.info("remove_data_note", {
        title: "remove_data_success",
      })
    );
  };
